<footer class="body back-cd900 txt-cd100">
    <div class="container-default p-4">
        <div class="grid grid-g-2">
            <div class="grid-col-12 grid-col-medium-6">
                <img src="../../../../assets/logo/logo-540px.webp" width="240px" loading="lazy" alt="Manava Immobilier" />
                <blockquote class="body-it txt-cd300">
                    <p class="body-it">« Choisissez un travail que vous aimez et vous n’aurez pas à travailler un seul jour dans votre vie. »</p>
                    <footer>Confucius</footer>
                </blockquote>
            </div>
            <div class="grid-col-12 grid-col-medium-3">
                <ul class="reset-list d-flex flex-column">
                    <li class="txt-w-bold">Pages</li>
                    <li class="c-pointer">
                        <a [routerLink]="'/'" class="h-100 w-100 txt-cd300 txt-deco-none txt-ws-nowrap">Accueil</a>
                    </li>
                    <li class="c-pointer">
                        <a [routerLink]="'/properties'" class="h-100 w-100 txt-cd300 txt-deco-none txt-ws-nowrap">Bien immobilier</a>
                    </li>
                    <li class="c-pointer">
                        <a [routerLink]="'/services'" class="h-100 w-100 txt-cd300 txt-deco-none txt-ws-nowrap">Services</a>
                    </li>
                    <li class="c-pointer">
                        <a [routerLink]="'/contact'" class="h-100 w-100 txt-cd300 txt-deco-none txt-ws-nowrap">Contact</a>
                    </li>
                    <li class="c-pointer">
                        <a [routerLink]="'/legal-notice'" class="h-100 w-100 txt-cd300 txt-deco-none txt-ws-nowrap">Mentions légales</a>
                    </li>
                </ul>
            </div>
            <div class="grid-col-12 grid-col-medium-3">
                <ul class="reset-list d-flex flex-column mb-2">
                    <li class="txt-w-bold">Réseau social</li>
                    <li class="c-pointer">
                        <a href="" class="h-100 w-100 txt-cd300 txt-deco-none txt-ws-nowrap">Facebook</a>
                    </li>
                    <li class="c-pointer">
                        <a href="" class="h-100 w-100 txt-cd300 txt-deco-none txt-ws-nowrap">Instagram</a>
                    </li>
                    <li class="c-pointer">
                        <a href="" class="h-100 w-100 txt-cd300 txt-deco-none txt-ws-nowrap">WhatsApp</a>
                    </li>
                </ul>
                <ul class="reset-list d-flex flex-column">
                    <li class="txt-w-bold">Coordonnées</li>
                    <li class="c-pointer">
                        <a href="tel:+68987701670" class="h-100 w-100 txt-cd300 callout txt-deco-none txt-ws-nowrap">+689 87 701 670</a>
                    </li>
                    <li class="c-pointer">
                        <a href="mailto:contact@manavaimmobilier.pf" class="h-100 w-100 txt-cd300 callout txt-deco-none txt-ws-nowrap">contact&#64;manavaimmobilier.pf</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>
<section class="d-flex flex-row justify-center items-center back-goldenrod-800">
    <div class="caption1-it px-4 py-2">
        <p class="txt-cd300">Copyright © 2026 SARL Groupe Pacific Immo. Tous droits réservés.</p>
    </div>
</section>
